export default "__VITE_ASSET__BLyxJap6__"